module.exports = __webpack_public_path__ + "img/icon_checkbox_on.e820487d.svg";